import {
  PostCommentsResponse,
  PostCreateBody,
  PostItem,
  PostListResponse,
} from "utils/api/client/types"

export class Posts {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }
  create(
    body: PostCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<PostItem> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/posts`, {
        method: "POST",
        headers,
        body,
        query,
      })
    })()
  }

  update(id: string, body: PostCreateBody): Promise<PostItem> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/posts/${id}`, {
        method: "PUT",
        body,
      })
    })()
  }

  list(
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<PostListResponse> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/posts`, {
        headers,
        query: queryParams,
      })
    })()
  }

  retrieve(id: string): Promise<PostItem> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/posts/${id}`)
    })()
  }

  delete(id: string, headers?: Record<string, unknown>): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/posts/${id}`, {
        method: "DELETE",
        headers,
      })
    })()
  }

  listComment(
    postId: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<PostCommentsResponse> {
    return (async () => {
      return await (this.client as any).fetch(
        `/admin/posts/${postId}/comments`,
        {
          headers,
          query: queryParams,
        }
      )
    })()
  }

  deleteComment(postId: string, commentId: string) {
    return (async () => {
      return await (this.client as any).fetch(
        `/admin/posts/${postId}/comments/${commentId}`,
        {
          method: "DELETE",
        }
      )
    })()
  }
}
